import { call, put, takeLatest, all } from 'redux-saga/effects';
import * as api from '../../api';
import { 
    fetchDashboardRequest, fetchDashboardSuccess, fetchDashboardFailure,
    updateProfileRequest, deleteProfileRequest, addEmployeeRequest, editEmployeeRequest, removeEmployeeRequest 
} from '../slices/userSlice';
import { logout } from '../slices/authSlice';

// --- FETCH DASHBOARD DATA ---
function* handleFetchDashboard() {
  try {
    const [profRes, licRes, statusRes] = yield all([
      call(() => api.getProfile().catch(() => ({ data: null }))),
      call(() => api.getMyLicense().catch(() => ({ data: { license: null } }))),
      call(() => api.checkStatus().catch(() => ({ data: null })))
    ]);
    yield put(fetchDashboardSuccess({
      profile: profRes.data,
      license: licRes.data?.license || null,
      status: statusRes.data || null
    }));
  } catch (error) {
    yield put(fetchDashboardFailure("Failed to load dashboard data"));
  }
}

// --- PROFILE ACTIONS ---
function* handleUpdateProfile(action) {
    try {
        yield call(api.updateProfile, action.payload);
        alert("Profile Updated Successfully!");
        yield put(fetchDashboardRequest());
    } catch (e) { alert("Update failed"); }
}

function* handleDeleteProfile() {
    try {
        yield call(api.deleteProfile);
        yield put(logout());
    } catch (e) { alert("Deletion failed"); }
}

// --- EMPLOYEE ACTIONS ---
function* handleEmployeeAction(apiCall, action, successMsg) {
    try {
        yield call(apiCall, action.payload);
        if(successMsg) alert(successMsg);
        yield put(fetchDashboardRequest()); // Refresh data
    } catch (e) { alert(e.response?.data?.message || "Action failed"); }
}

export default function* userSaga() {
  yield takeLatest(fetchDashboardRequest.type, handleFetchDashboard);
  yield takeLatest(updateProfileRequest.type, handleUpdateProfile);
  yield takeLatest(deleteProfileRequest.type, handleDeleteProfile);
  
  yield takeLatest(addEmployeeRequest.type, (a) => handleEmployeeAction(api.userAddEmployee, a, "Employee Added!"));
  yield takeLatest(editEmployeeRequest.type, (a) => handleEmployeeAction(api.userEditEmployee, a, "Employee Updated!"));
  yield takeLatest(removeEmployeeRequest.type, (a) => handleEmployeeAction(api.userRemoveEmployee, a, "Employee Removed!"));
}